// ENG-2015: the CP portal's and the operator dashboard's Sign buttons open the CP and co-sign pages in a new
// tab with this flag on the URL. After a successful submit that tab closes, and the browser goes back to the portal.
export const CLOSE_ON_SUBMIT_PARAM = "close_on_submit";

export const closesOnSubmit = (search) =>
  new URLSearchParams(search || "").get(CLOSE_ON_SUBMIT_PARAM) === "1";

// Where the signer lands when the tab stays open: the pages the submit has always gone to
export const pageAfterSubmit = (isCp, appUrl) =>
  isCp ? "/collab-phys-sign/complete" : `${appUrl}/app/operator/video`;

// A browser refuses a close it doesn't allow without an error, so a tab still open afterwards goes to the page instead
export function closeTabOrGoTo(win, url) {
  if (closesOnSubmit(win.location.search)) {
    win.close();
    if (win.closed) return;
  }
  win.location.href = url;
}
